import { allowed, defaults } from '../../../../lib/genericReducer';

export default function reducer(
  state = {
    authenticated: false,
    authenticationType: 'local',
    associated: false,
    currentId: null,
    error: null,
    fetching: false,
    fetched: false,
    masqueradeUser: {},
    isMasquerade: false,
    loginMessage: '',
    registered: false,
    registerMessage: '',
    resetMessage: null,
    responseMessage: null,
    responseMessageColour: 'text-danger',
    verifyMessage: null,
    verified: false,
  },
  action,
) {
  // Set expected reducer types
  const types = [
    'AUTHENTICATION',
    'AUTHENTICATED',
    'FORGOT',
    'INVITE',
    'MODE',
    'LOGIN',
    'LOGOUT',
    'MASQUERADE',
    'MASQUERADE',
    'PASSWORD',
    'REALM',
    'REGISTRATION',
    'TOKEN',
    'USER',
    'VERIFY',
  ];

  if (!allowed(types, action)) {
    return state;
  }

  // Set defaults
  const updatedState = {
    ...state,
    ...defaults(action),
  };

  switch (action.type) {
    case 'GENERATE_PASSWORD_RESET_LINK_FULFILLED': {
      return {
        ...updatedState,
        responseMessage: action.payload,
        responseMessageColour: 'text-success',
      };
    }
    case 'SET_LOGIN_MESSAGE': {
      return {
        ...updatedState,
        loginMessage: action.payload,
      };
    }
    case 'SET_AUTHENTICATION_TYPE': {
      return {
        ...updatedState,
        authenticationType: action.payload,
      };
    }
    case 'SET_MASQUERADE': {
      const { authorized: isMasquerade, masqueradeUser } = action.payload;
      return {
        ...updatedState,
        isMasquerade,
        masqueradeUser,
      };
    }
    case 'ASSOCIATE_USER_FULFILLED': {
      return {
        ...updatedState,
        associated: true,
      };
    }

    case 'REGISTRATION_PENDING': {
      return {
        ...updatedState,
      };
    }
    case 'REGISTRATION_FULFILLED': {
      return {
        ...updatedState,
        registered: action.payload,
        registerMessage: '',
      };
    }
    case 'SET_AUTHENTICATED_FULFILLED': {
      return {
        ...updatedState,
        authenticated: action.payload,
      };
    }
    case 'FETCH_TOKEN_FULFILLED': {
      return {
        ...updatedState,
        authenticated: action.payload.authenticated,
      };
    }
    case 'SET_VERIFY_FULFILLED': {
      return {
        ...updatedState,
        verified: action.payload,
      };
    }
    case 'FETCH_INVITE_FULFILLED': {
      return {
        ...updatedState,
        registerMessage: null,
        verified: action.payload,
      };
    }
    case 'FETCH_HASH_USER_FULFILLED': {
      return {
        ...updatedState,
        resetMessage: null,
      };
    }
    case 'UPDATE_PASSWORD_FULFILLED': {
      return {
        ...updatedState,
        responseMessage: null,
      };
    }
    case 'FORGOT_FULFILLED': {
      return {
        ...updatedState,
        responseMessageColour: 'text-success',
        responseMessage: action.payload,
      };
    }
    /* This is a special action set by the generic action when an authorisation
     * error occurs on one of our endpoints */
    case 'AUTHENTICATION_ERROR': {
      return {
        ...updatedState,
        responseMessage: action.payload,
        authenticated: false,
      };
    }

    default:
      break;
  }
  return updatedState;
}
